export const initialResetPassword = {
  password: '',
  repeatPassword: '',
};
